export enum ENV_NAME {
    DEV = 'DEV',
    PROD = 'PROD',
}

enum ENC_KEY {
    DEV = 'u4TQZNrxaSgaLvCi',
    PROD = 'rqdc9PZJk2CwPATD',
}

enum KEY_AUTH {
    DEV = 'Eq3VTyM74WWu8yGy',
    PROD = 'bpVE3oXN9Ova1ZRx',
}

export enum ENV_HOST {
    DEV = 'https://gorgw-dev.cocokobe.com/',
    PROD = 'https://aoc.gorgw1.cc/',
}

interface envKeys {
    crypt_key: ENC_KEY
    crypt_key_auth: KEY_AUTH
    open_crypt: boolean
    ApiHost: string
    ApiUrl: string
}

type Env = Record<ENV_NAME, envKeys>
export const GLOBAL_ENV: Env = {
    [ENV_NAME.DEV]: {
        crypt_key: ENC_KEY.DEV,
        crypt_key_auth: KEY_AUTH.DEV,
        open_crypt: false,
        ApiHost: `${ENV_HOST.DEV}`,
        ApiUrl: `${ENV_HOST.DEV}gor-manage`,
    },
    [ENV_NAME.PROD]: {
        crypt_key: ENC_KEY.PROD,
        crypt_key_auth: KEY_AUTH.PROD,
        open_crypt: true,
        ApiHost: `${ENV_HOST.PROD}`,
        ApiUrl: `${ENV_HOST.PROD}gor-manage`,
    },
}

export const getEnvConfig = () => {
    let currentEnv = process.env.REACT_APP_ENV as ENV_NAME
    let envName = currentEnv || ENV_NAME.DEV

    return GLOBAL_ENV[envName]
}
